import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfig } from '../app-config';
import { APP_CONFIG } from '../app-config.token';
import { StartSignatureRequest } from '../contracts/requests/start-signature-request';
import { CompleteSignatureRequest } from '../contracts/requests/complete-signature-request';
import { StartSignatureResponse } from '../contracts/responses/start-signature-response';
import { CompleteSignatureResponse } from '../contracts/responses/complete-signature-response';
import { HandleCallbackResponse } from '../contracts/responses/handle-callback-response';

@Injectable({
  providedIn: 'root',
})
export class SignatureService {
  private http = inject(HttpClient);
  private config = inject<AppConfig>(APP_CONFIG);

  private readonly API_URL = this.config.resourceApiURI + '/signature';

  constructor() { }

  /**
   * Rozpoczyna proces podpisu dokumentów przez SimplySign OAuth2 flow
   * @param request Żądanie zawierające userId, fileIds i typ pliku
   * @returns Odpowiedź z URL autoryzacji SimplySign i sessionId
   */
  startSignature(request: StartSignatureRequest): Observable<StartSignatureResponse> {
    const url = `${this.API_URL}/start`;
    return this.http.post<StartSignatureResponse>(url, request);
  }

  /**
   * Obsługuje callback OAuth2 z SimplySign
   * Przekazuje authorization code i state do backendu
   * @param code Authorization code z SimplySign (zaczyna się od "OC-")
   * @param state CSRF protection state
   * @returns Odpowiedź z sessionId i fileIds do przekierowania użytkownika do dialogu PIN
   */
  handleCallback(code: string, state: string): Observable<HandleCallbackResponse> {
    const url = `${this.API_URL}/callback`;
    return this.http.get<HandleCallbackResponse>(url, { params: { code, state } });
  }

  /**
   * Forward the browser to backend callback endpoint so the backend can perform a redirect (302)
   * This is required when backend returns an HTTP redirect instead of JSON for the callback.
   */
  forwardToBackend(code: string, state: string): void {
    // Build URL: {resourceApiURI}/signature/callback?code=...&state=...
    const url = `${this.config.resourceApiURI.replace(/\/$/, '')}/signature/callback?code=${encodeURIComponent(code)}&state=${encodeURIComponent(state)}`;
    // Perform full navigation so browser follows backend redirects
    window.location.href = url;
  }

  /**
   * Finalizuje proces podpisu po wprowadzeniu PIN przez użytkownika
   * @param request Żądanie zawierające sessionId, PIN i fileIds
   * @returns Odpowiedź z podpisanymi plikami lub błędem
   */
  completeSignature(request: CompleteSignatureRequest): Observable<CompleteSignatureResponse> {
    const url = `${this.API_URL}/complete`;
    return this.http.post<CompleteSignatureResponse>(url, request);
  }
}
